import { Button, Flex, Skeleton } from '@chakra-ui/react';
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

import CapitalProviderContextProvider from 'packages/organization/hooks/CapitalProviderContextProvider';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { FinancialCovenantsContainer } from '~/packages/borrowing-base/ui/FinancialCovenantsContainer';
import {
  InsightsTemplate,
  TAB_OPTION_KEYS,
} from '~/packages/borrowing-base/ui/InsightsTemplate';
import { useCreditFacilityContext } from '~/packages/credit-facility/hooks/CreditFacilityProvider';
import { FinancialStatementsContainer } from '~/packages/financial-data/ui/financialStatements/FinancialStatementsContainer';

const FinancialViewsIterable = [
  'Financial Covenants',
  'Financial Statements',
] as const;
type FinancialViewsTypes = typeof FinancialViewsIterable[number];

const RouteBase = () => {
  const flags = useFeatureFlags();
  const { creditFacilityId } = useCreditFacilityContext();
  const [
    selectedFinancialView,
    setSelectedFinancialView,
  ] = useState<FinancialViewsTypes>('Financial Covenants');

  return (
    <InsightsTemplate selectedTab={TAB_OPTION_KEYS.financials}>
      <Flex direction="column" gap="2.5rem">
        <Flex gap="0.5rem">
          {FinancialViewsIterable.filter(
            (financialView) =>
              flags.isFinancialStatementsDashboardEnabled ||
              financialView !== 'Financial Statements',
          ).map((financialView) => (
            <Button
              key={financialView}
              variant="primary-muted"
              colorScheme="gray"
              isActive={selectedFinancialView === financialView}
              onClick={() => setSelectedFinancialView(financialView)}
            >
              {financialView}
            </Button>
          ))}
        </Flex>
        {selectedFinancialView === 'Financial Covenants' && (
          <CapitalProviderContextProvider renderLoading={<Skeleton />}>
            <FinancialCovenantsContainer creditFacilityId={creditFacilityId} />
          </CapitalProviderContextProvider>
        )}
        {selectedFinancialView === 'Financial Statements' && (
          <FinancialStatementsContainer creditFacilityId={creditFacilityId} />
        )}
      </Flex>
    </InsightsTemplate>
  );
};

export const InsightsFinancialsRoute = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/insights/funding-overview" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
